import BaseService from './BaseService';

const resource = 'api/v3/sap/?url=/api_scc_cc/';

class AppService extends BaseService {
  constructor() {
    super({ resource });
  }

  /**
   * Retry helper with exponential backoff
   * @param {Function} fn - Function to retry
   * @param {number} maxRetries - Maximum number of retries (default: 3)
   * @param {number} baseDelay - Base delay in ms (default: 1000)
   * @returns {Promise} Result of the function
   */
  async retryWithBackoff(fn, maxRetries = 3, baseDelay = 1000) {
    let lastError;

    for (let attempt = 0; attempt < maxRetries; attempt++) {
      try {
        return await fn();
      } catch (error) {
        lastError = error;

        // Only retry on network errors or 502/503/504 status codes
        const shouldRetry = !error.response
          || [502, 503, 504].includes(error.response?.status);

        if (!shouldRetry || attempt === maxRetries - 1) {
          throw error;
        }

        // Exponential backoff: 1s, 2s, 4s
        const delay = baseDelay * 2 ** attempt;
        await new Promise((resolve) => setTimeout(resolve, delay));
      }
    }

    throw lastError;
  }

  async getFileConfig() {
    const action = 'document-required/';
    return this.retryWithBackoff(() => this.http.get(this.resource + action));
  }

  async getContractorMaterial(id) {
    const action = `request-contractor-type/${id}/`;
    return this.retryWithBackoff(() => this.http.get(this.resource + action));
  }
}

export default AppService;
